import { Modal } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { useQueryClient } from "@tanstack/react-query";
import { Button, ButtonGroup } from "../../Form";
import { useApi } from "../../../hooks";

type Props = {
  handleNext?: $TSFixMeFunction;
  onClose: $TSFixMeFunction;
  existingDataExport?: {
    id: number;
  };
};

function DataExportExistsStep({
  handleNext,
  onClose,
  existingDataExport,
}: Props) {
  const intl = useIntl();
  const api = useApi();
  const queryClient = useQueryClient();

  const { mutate: deleteExistingExport, isLoading } = api.delete.useMutation(
    `/users/current/data_exports/${existingDataExport?.id}`,
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["/users/current/data_exports"],
        });
      },
    },
  );

  const handleConfirmClick = () => {
    // @ts-expect-error TS(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    deleteExistingExport(null, {
      onSuccess: () => {
        // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        handleNext();
      },
    });
  };

  return (
    <div className="data-export-exists-step">
      <Modal.Body>
        <h3>
          <FormattedMessage id="export_files_dialog_delete.title" />
        </h3>
        <p>
          <FormattedMessage id="export_files_dialog_delete.text" />
        </p>
        <br />
        <b>
          <FormattedMessage id="export_files_dialog_delete.hint" />
        </b>
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button
            text={intl.formatMessage({ id: "button.close" })}
            onClick={onClose}
          />
          <Button
            hero
            fetching={isLoading}
            text={intl.formatMessage({ id: "button.delete" })}
            onClick={handleConfirmClick}
          />
        </ButtonGroup>
      </Modal.Footer>
    </div>
  );
}

export default DataExportExistsStep;
